import { type IIntegrationKey } from 'entities/Integrations'

export const MICROSERVICE_INTEGRATIONS: IIntegrationKey[] = ['salesforce']
